// extracted by mini-css-extract-plugin
export var blink = "_5t-2";
export var cursor = "_5t-1";
export var reactMarkdown = "_5t-3";
export var streamingText = "_5t-0";